import { render } from "./PrimaryNavigation.vue.js?vue&type=template&id=4c60fed7!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PrimaryNavigation.vue?vue&type=template&id=4c60fed7"
import script from "./PrimaryNavigation.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PrimaryNavigation.vue?vue&type=script&lang=js"
export * from "./PrimaryNavigation.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PrimaryNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/navigation/PrimaryNavigation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c60fed7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c60fed7', __exports__)) {
    api.reload('4c60fed7', __exports__)
  }
  
  module.hot.accept("./PrimaryNavigation.vue.js?vue&type=template&id=4c60fed7!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PrimaryNavigation.vue?vue&type=template&id=4c60fed7", () => {
    api.rerender('4c60fed7', render)
  })

}


export default __exports__